import React, { useEffect, useState } from 'react';
import TreeView from 'react-treeview';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../components/helpers/Translator';
import colors from '../../../../constants/colors';

export default function PublicationPathLayer({
  folder,
  collapsed,
  setFieldValue,
  selectedFolderHex,
}) {
  const [collapsedState, setCollapsedState] = useState(collapsed || true);

  useEffect(() => {
    if (collapsed === false) setCollapsedState(collapsed);
    else setCollapsedState(true);
  }, [collapsed]);

  return (
    <>
      <TreeView
        nodeLabel={
          <div
            className="marked d-inline-flex align-items-center pointer"
            style={{
              color: `${
                selectedFolderHex === folder?.hex ? colors.success : ''
              }`,
            }}
          >
            <span
              className="ml-2 mr-2"
              onClick={() => setFieldValue('selectedFolderHex', folder?.hex)}
            >
              {folder.title}
            </span>
            {selectedFolderHex === folder?.hex && (
              <AppRemixIcon
                icon="checkbox"
                title={ReactDOMServer.renderToString(
                  <Translator file="general" name="general.edit" />
                )}
              />
            )}
          </div>
        }
        collapsed={collapsedState}
        onClick={() => setCollapsedState(!collapsedState)}
      >
        {folder.subfolders?.map((sf) => (
          <PublicationPathLayer
            key={sf.hex}
            id={sf.hex}
            folder={sf}
            parentID={folder?.hex}
            collapsed={collapsed}
            setFieldValue={setFieldValue}
            selectedFolderHex={selectedFolderHex}
          />
        ))}
      </TreeView>
    </>
  );
}
